import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Spinner, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import moment from "moment";
import "./Package.css"
import airlinesData from "../../Data/airlines.json";
import airportsData from "../../Data/AirportList.json"; 

const ChangeFlightModal = ({ show, onHide, flights, isLoading, onSelect, currentlySelectedFlight }) => {
  const flightLegs = flights && flights.length > 0 ? flights[0].dcFlightLegs : [];

  function getTimeFromMins(mins) {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}h ${m}m`;
  }

  return (
    // 1. ADD a scoping className here
    <Modal 
      show={show} 
      onHide={onHide} 
      size="xl" 
      centered 
      dialogClassName="package-flight-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title><i className="ri-plane-line me-2"></i>Change Flight</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <Table className="flight-results-table">
            <tbody>
              {isLoading && (
                <tr>
                  <td className="text-center p-5">
                    <Spinner animation="border" />
                    <p className="mt-2 mb-0">Searching for alternative flights...</p>
                  </td>
                </tr>
              )}
              {!isLoading && flightLegs && flightLegs.length > 0 ? (
                flightLegs.map((leg, index) => {
                  const displayLeg = leg?.dcDisplayLegs?.[0];
                  if (!displayLeg) return null;
                  const cheapestFare = leg.dcPriceDetails.reduce(
                    (min, curr) => (curr.totalPrice < min.totalPrice ? curr : min),
                    leg.dcPriceDetails[0]
                  );

                  const isSelected = currentlySelectedFlight?.productKey === leg.productKey;
                  
                  return (
                    <tr key={leg.productKey || index} className="flight-card-row">
                      <td className="flight-card-cell">
                        <div className="flight-card-container">
                          {/* Airline Info */}
                          <div className="flight-col airline-info">
                             <img
                                src={`/assets/images/airlinelogos/${displayLeg.airlineData?.airlineCode}.png`}
                                alt={displayLeg.airlineData?.airlineCode}
                                className="airline-logo"
                              />
                            <div>
                              <div className="airline-name">{displayLeg.airlineData?.airline}</div>
                              <div className="flight-number text-muted">{displayLeg.airlineData?.airlineCode}-{displayLeg.airlineData?.flightNumber}</div>
                            </div>
                          </div>

                          {/* Departure Info */}
                          <div className="flight-col time-info">
                            <div className="time">{moment(displayLeg.startSegment?.departureDateTime).format("HH:mm")}</div>
                            <div className="city-code">{displayLeg.startSegment?.cityCode}</div>
                            <div className="date text-muted">{moment(displayLeg.startSegment?.departureDateTime).format("DD MMM YY")}</div>
                          </div>

                          {/* Duration Info */}
                          <div className="flight-col duration-info">
                            <div className="duration">{getTimeFromMins(displayLeg.totalDuration)}</div>
                            <div className="stops-line"></div>
                            <div className="stops-text text-muted">{displayLeg.stops === 0 ? "Non-stop" : `${displayLeg.stops} Stop(s)`}</div>
                          </div>
                          
                          {/* Arrival Info */}
                          <div className="flight-col time-info">
                            <div className="time">{moment(displayLeg.endSegment?.arrivalDateTime).format("HH:mm")}</div>
                            <div className="city-code">{displayLeg.endSegment?.cityCode}</div>
                            <div className="date text-muted">{moment(displayLeg.endSegment?.arrivalDateTime).format("DD MMM YY")}</div>
                          </div>

                          {/* Fare Info */}
                          <div className="flight-col fare-info">
                            {/* <span className="badge bg-soft-secondary text-secondary-emphasis mb-1">{cheapestFare?.fareIdentifier}</span> */}
                            <div className="price">INR {cheapestFare?.totalPrice.toFixed(2)}</div>
                            {/* <button className="btn btn-link btn-sm p-0">View Fares</button> */}
                          </div>

                          {/* Action Info */}
                          <div className="flight-col action-info">
                            <Button variant={isSelected ? "success" : "primary"} size="sm" onClick={() => onSelect(leg)}>
                               {isSelected ? "SELECTED" : "SELECT"}
                            </Button>
                             
                          </div>

                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                !isLoading && (
                  <tr>
                    <td className="text-center p-4">
                      <h5>No alternative flights found.</h5>
                      <p className="text-muted mb-0">The session may have expired or no flights match the criteria.</p>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const PackageFlightBooking = ({ packageId, packageDetails }) => {
  const initialFieldValues = {
    packageFlightBookingId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    airline: "",
    flightNumber: "",
    departureCity: "",
    arrivalCity: "",
    departureDateTime: "",
    arrivalDateTime: "",
    cabinClass: "Economy",
    price: ""
  };
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [data, setData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
   const [isFormVisible, setIsFormVisible] = useState(false);

   const [showChangeFlightModal, setShowChangeFlightModal] = useState(false);
  const [alternativeFlights, setAlternativeFlights] = useState([]);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [flightToUpdate, setFlightToUpdate] = useState(null);
    const [currentlySelectedFlightInModal, setCurrentlySelectedFlightInModal] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [isSuggestionsVisible, setIsSuggestionsVisible] = useState(false);
    const airlineInputWrapperRef = useRef(null); 
    const [departureSuggestions, setDepartureSuggestions] = useState([]);
    const [arrivalSuggestions, setArrivalSuggestions] = useState([]);
    const departureInputRef = useRef(null);
    const arrivalInputRef = useRef(null);

     useEffect(() => {
        const handleClickOutside = (event) => {
            if (airlineInputWrapperRef.current && !airlineInputWrapperRef.current.contains(event.target)) {
                setIsSuggestionsVisible(false);
            }
            if (departureInputRef.current && !departureInputRef.current.contains(event.target)) {
                setDepartureSuggestions([]);
            }
            if (arrivalInputRef.current && !arrivalInputRef.current.contains(event.target)) {
                setArrivalSuggestions([]);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
  
  useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  
  


  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

   const handleAddNewClick = () => {
    resetForm();
    setIsFormVisible(true);
  };

  
  

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async () => {
    const res = await apiService.get(
      `${config.GETFLIGHTBYPACKAGEID}/${packageId}`
    );
    console.log(res);
    setLists(res.data);
    setData(res.data);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGEFLIGHT, itemToDelete);
        await GetData();
      } catch (error) {
      }
      handleCloseDeleteModal();
    }
  };
  const showEditDetails = (data) => {
    const formattedData = {
        ...data,
        departureDateTime: moment(data.departureDateTime).format("YYYY-MM-DDTHH:mm"),
        arrivalDateTime: moment(data.arrivalDateTime).format("YYYY-MM-DDTHH:mm"),
    };
    setRecordForEdit(formattedData);
    setValues(formattedData);
    setIsFormVisible(true);
  };

  const validate = () => {
    let temp = {};
    temp.airline = values.airline === "" ? false : true;
   
    temp.departureCity = values.departureCity === "" ? false : true;
    temp.arrivalCity = values.arrivalCity === "" ? false : true;
    temp.departureDateTime = values.departureDateTime === "" ? false : true;
    temp.arrivalDateTime = values.arrivalDateTime === "" ? false : true;
    temp.cabinClass = values.cabinClass === "" ? false : true;
    temp.price = values.price !== "" && !isNaN(values.price) && parseFloat(values.price) >= 0;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageFlightBookingId: values.packageFlightBookingId,
        packageId: packageId,
        airline: values.airline,
        flightNumber: values.flightNumber,
        departureCity: values.departureCity,
        arrivalCity: values.arrivalCity,
        departureDateTime: values.departureDateTime,
        arrivalDateTime: values.arrivalDateTime,
        cabinClass: values.cabinClass,
        price: values.price,
        userId: user?.id,
      };
      try {
        const isNew =
          formData.packageFlightBookingId ===
          "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGEFLIGHT, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGEFLIGHT, formData);
        }
        await GetData();
        resetForm();
        setIsFormVisible(false); 
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleCancel = () => {
      resetForm();
      setIsFormVisible(false);
  };


 const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });

        // Airline autocomplete logic
        if (name === "airline") {
            if (value) {
                const filteredSuggestions = airlinesData.filter(airline =>
                    airline.name.toLowerCase().includes(value.toLowerCase())
                );
                setSuggestions(filteredSuggestions);
                setIsSuggestionsVisible(true);
            } else {
                setSuggestions([]);
                setIsSuggestionsVisible(false);
            }
        }

        // --- NEW --- Airport autocomplete logic
        if (name === "departureCity" || name === "arrivalCity") {
            if (value.length > 2) {
                const lowerValue = value.toLowerCase();
                const filteredAirports = airportsData.filter(airport =>
                    airport.cityName.toLowerCase().includes(lowerValue) ||
                    airport.airportCode.toLowerCase().includes(lowerValue) ||
                    airport.airportName.toLowerCase().includes(lowerValue)
                ).slice(0, 7); // Limit to 7 results for performance

                if (name === "departureCity") {
                    setDepartureSuggestions(filteredAirports);
                } else {
                    setArrivalSuggestions(filteredAirports);
                }
            } else {
                setDepartureSuggestions([]);
                setArrivalSuggestions([]);
            }
        }
    };

const handleSuggestionClick = (airlineName) => {
        setValues({ ...values, airline: airlineName });
        setSuggestions([]);
        setIsSuggestionsVisible(false);
    };

    // --- NEW --- Function to handle airport selection
    const handleAirportSelect = (fieldName, airport) => {
        const displayValue = `${airport.cityName} (${airport.airportCode})`;
        setValues({
            ...values,
            [fieldName]: displayValue
        });

        // Clear respective suggestions
        if (fieldName === 'departureCity') {
            setDepartureSuggestions([]);
        } else {
            setArrivalSuggestions([]);
        }
    };

  const resetForm = () => {
    setValues(initialFieldValues);
    setRecordForEdit(null);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) => (errors[field] === false ? " form-control-danger" : "");
const extractAirportCode = (cityString) => {
    if (!cityString || !cityString.includes('(')) {
        return cityString; 
    }
    const match = cityString.match(/\((.*?)\)/);
    return match ? match[1] : cityString;
};
const handleChangeFlightClick = async (flightBooking) => {
    setFlightToUpdate(flightBooking);
    setShowChangeFlightModal(true);
    setIsModalLoading(true);
    setAlternativeFlights([]);

    try {
      const flightSearchRequest = {
        adults: flightBooking.adults || packageDetails?.adults || 1, 
        kids: flightBooking.kids || packageDetails?.kids || 0,
        infants: flightBooking.infants || packageDetails?.infants || 0,
        journeyType: "ONEWAY",
        cabinClass: packageDetails?.cabinClass || "ECONOMY",
        isDomestic: "DOMESTIC",
        isDirectFlight: false,
        preferred: "REGULAR",
        companyId: user.cid,
       flightTravelerPoints: [{
                    from: extractAirportCode(flightBooking.departureCity),
                    to: extractAirportCode(flightBooking.arrivalCity),     
                    departureDate: moment(flightBooking.departureDateTime).format("YYYY-MM-DD"),
                    returnDate: moment(flightBooking.departureDateTime).format("YYYY-MM-DD"),
                }]
      };
      console.log("payload", flightSearchRequest)
      const res = await apiService.post(config.SEARCHFLIGHTALTERNATIVES, flightSearchRequest);
      
      console.log("console res", res)
      setAlternativeFlights(res);

    } catch (error) {
      toast.error(error.response?.data?.message || "Could not load alternative flights.");
      setShowChangeFlightModal(false);
    } finally {
      setIsModalLoading(false);
    }
  };
const handleSelectNewFlight = async (selectedLeg) => {
  if (!flightToUpdate || !selectedLeg) {
    toast.error("An error occurred. Missing flight information.");
    return;
  }

  setBtnLoading(true); 
  setCurrentlySelectedFlightInModal(selectedLeg); 
  try {
    // 2. Extract all the necessary data from the newly selected flight (`selectedLeg`).
    // It's good practice to use optional chaining (?.) to prevent errors if data is missing.
    const displayLeg = selectedLeg?.dcDisplayLegs?.[0];
    const startSegment = displayLeg?.startSegment;
    const endSegment = displayLeg?.endSegment;
    const airlineData = displayLeg?.airlineData;

    const cheapestFare = selectedLeg.dcPriceDetails.reduce(
            (min, curr) => (curr.totalPrice < min.totalPrice ? curr : min),
            selectedLeg.dcPriceDetails[0]
        );
        const newFlightPrice = cheapestFare?.totalPrice;

    // More validation to ensure the nested data exists.
    if (!displayLeg || !startSegment || !endSegment || !airlineData) {
      toast.error("The selected flight has incomplete data. Cannot proceed.");
      throw new Error("Incomplete flight data from selection."); // This will be caught by the catch block.
    }
    
    const formData = {
      packageFlightBookingId: flightToUpdate.packageFlightBookingId, 
      packageId: packageId,
      userId: user?.id,
      airline: airlineData.airline,
      flightNumber: airlineData.flightNumber,
      departureCity: flightToUpdate.departureCity, 
      arrivalCity: flightToUpdate.arrivalCity,     
      departureDateTime: startSegment.departureDateTime,
      arrivalDateTime: endSegment.arrivalDateTime,
      cabinClass: flightToUpdate.cabinClass, 
      price: newFlightPrice
      
    };
    await apiService.update(config.UPDATEPACKAGEFLIGHT, formData);

    setShowChangeFlightModal(false); 
    await GetData(); 
    setCurrentlySelectedFlightInModal(null);

  } catch (error) {
    
    console.error("Failed to update flight:", error);
    
  } finally {
    
    setBtnLoading(false);
  }
};
const getCleanCityName = (airport) => {
        if (!airport || !airport.cityName) return '';
        return airport.cityName.split(',')[0];
    };
    
  return (
    <div className="PackageFlight-wrapper">
      <div className="card PackageFlight-card">
        <div className="card-body">
          <div className="PackageFlight-header">
            <h4 className="header-title">Flight Bookings</h4>
            {!isFormVisible && (
              <button
                type="button"
                className="btn btn-primary PackageFlight-btn-gradient"
                onClick={handleAddNewClick}
              >
                <i className="ri-add-line me-1"></i> Add New Flight
              </button>
            )}
          </div>
          {isFormVisible && (
            <div className="PackageFlight-form-container">
              <h5 className="form-title">
                {values.packageFlightBookingId === "00000000-0000-0000-0000-000000000000"
                  ? "Add Flight Details"
                  : "Edit Flight Details"}
              </h5>
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                   <div className="col-lg-3 mb-3">
                                <label className="form-label d-flex align-items-center"><i className="ri-plane-line me-2"></i>Airline</label>
                                <div className="airline-autocomplete-wrapper" ref={airlineInputWrapperRef}>
                                    <input
                                        type="text"
                                        name="airline"
                                        value={values.airline}
                                        onChange={handleInputChange}
                                        className={"form-control" + applyErrorClass("airline")}
                                        placeholder="IndiGo"
                                        onClick={() => values.airline && setIsSuggestionsVisible(true)} // Show on click if there's text
                                    />
                                    {isSuggestionsVisible && suggestions.length > 0 && (
                                        <ul className="airline-suggestions-list">
                                            {suggestions.map((airline) => (
                                                <li
                                                    key={airline.code}
                                                    className="airline-suggestion-item"
                                                    onClick={() => handleSuggestionClick(airline.name)}
                                                >
                                                    <div className="airline-name">{airline.name}</div>
                                                    <div className="airline-code">Airline Code: {airline.code}</div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            
                  <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-hashtag me-2"></i>Flight Number</label>
                      <input type="text" name="flightNumber" value={values.flightNumber} onChange={handleInputChange} className={"form-control" + applyErrorClass("flightNumber")} placeholder="EK516"/>
                  </div>
 <div className="col-lg-3 mb-3">
                                        <label className="form-label d-flex align-items-center"><i className="ri-flight-takeoff-line me-2"></i>Departure City</label>
                                        <div className="airline-autocomplete-wrapper" ref={departureInputRef}>
                                            <input 
                                                type="text" 
                                                name="departureCity" 
                                                value={values.departureCity} 
                                                onChange={handleInputChange} 
                                                className={"form-control" + applyErrorClass("departureCity")} 
                                                placeholder="Hyderabad (HYD)"
                                            />
                                            {departureSuggestions.length > 0 && (
                                                <ul className="airline-suggestions-list">
                                                    {departureSuggestions.map(airport => (
                                                        <li key={airport.airportCode}  className="airline-suggestion-item" onClick={() => handleAirportSelect('departureCity', airport)}>
                                                            <div className="airline-name">{getCleanCityName(airport)} ({airport.airportCode})</div>
                                                            <div className="airline-code">{airport.airportName}, {airport.countryName}</div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                             {errors.departureCity === false && <div className="validationerror">Please select departure city</div>}
                                        </div>
                                    </div>

                                    {/* --- MODIFIED --- Arrival City Input with Autocomplete */}
                                    <div className="col-lg-3 mb-3">
                                        <label className="form-label d-flex align-items-center"><i className="ri-flight-land-line me-2"></i>Arrival City</label>
                                        <div className="airline-autocomplete-wrapper" ref={arrivalInputRef}>
                                            <input 
                                                type="text" 
                                                name="arrivalCity" 
                                                value={values.arrivalCity} 
                                                onChange={handleInputChange} 
                                                className={"form-control" + applyErrorClass("arrivalCity")} 
                                                placeholder="Dubai (DXB)"
                                            />
                                            {arrivalSuggestions.length > 0 && (
                                                <ul className="airline-suggestions-list">
                                                    {arrivalSuggestions.map(airport => (
                                                        <li key={airport.airportCode} className="airline-suggestion-item" onClick={() => handleAirportSelect('arrivalCity', airport)}>
                                                            <div className="airline-name">{getCleanCityName(airport)} ({airport.airportCode})</div>
                                                            <div className="airline-code">{airport.airportName}, {airport.countryName}</div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                            {errors.arrivalCity === false && <div className="validationerror">Please select arrival city</div>}
                                        </div>
                                    </div>
                  <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-calendar-event-line me-2"></i>Departure Date/Time</label>
                       <input type="datetime-local" name="departureDateTime" value={values.departureDateTime} onChange={handleInputChange} className={"form-control" + applyErrorClass("departureDateTime")}/>
                  </div>
                  <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-calendar-check-line me-2"></i>Arrival Date/Time</label>
                       <input type="datetime-local" name="arrivalDateTime" value={values.arrivalDateTime} onChange={handleInputChange} className={"form-control" + applyErrorClass("arrivalDateTime")}/>
                  </div>
                   <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-shield-star-line me-2"></i>Cabin Class</label>
                       <select name="cabinClass" value={values.cabinClass} onChange={handleInputChange} className={"form-select" + applyErrorClass("cabinClass")}>
                           <option value="">Select Class</option>
                           <option value="Economy">Economy</option>
                           <option value="Premium Economy">Premium Economy</option>
                           <option value="Business">Business</option>
                           <option value="First Class">First Class</option>
                       </select>
                  </div>
                   <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-money-dollar-circle-line me-2"></i>Price</label>
                       <input 
                           type="number" 
                           name="price" 
                           value={values.price} 
                           onChange={handleInputChange} 
                           className={"form-control" + applyErrorClass("price")} 
                           placeholder="15000"
                       />
                       {errors.price === false && <div className="validationerror">Please enter a valid price</div>}
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <button type="button" className="btn btn-light" onClick={handleCancel}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={btnLoading}>
                        {btnLoading ? "Saving..." : (values.packageFlightBookingId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update")}
                    </button>
                </div>
              </form>
            </div>
          )}
          <div className="table-responsive mt-4">
            <table className="table PackageFlight-table">
              <thead className="PackageFlight-table-header">
                <tr>
                  <th>S No.</th>
                  <th>Airline</th>
                  <th>Flight Details</th>
                  <th>Departure</th>
                  <th>Arrival</th>
                  <th>Class</th>
                  <th>Price</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {lists.length > 0 ? (
                  lists.map((v, index) => (
                    <tr key={v.packageFlightBookingId} className="PackageFlight-table-row">
                      <td>{index + 1}</td>
                      <td>{v.airline}</td>
                      <td>{v.flightNumber}</td>
                      <td>
  <div className="fw-medium">{v.departureCity}</div>
  <div className="datetime-text">
    {moment(v.departureDateTime).format("HH:mm") === "00:00"
      ? moment(v.departureDateTime).format("DD MMM YYYY")
      : moment(v.departureDateTime).format("DD MMM YYYY, HH:mm")}
  </div>
</td>
<td>
  <div className="fw-medium">{v.arrivalCity}</div>
  <div className="datetime-text">
    {moment(v.arrivalDateTime).format("HH:mm") === "00:00"
      ? moment(v.arrivalDateTime).format("DD MMM YYYY")
      : moment(v.arrivalDateTime).format("DD MMM YYYY, HH:mm")}
  </div>
</td>

                      <td>{v.cabinClass}</td>
                      <td>{v.price}</td>
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          {packageDetails?.isLive && (
                        <button
                          className="PackageFlight-action-btn change"
                          title="Change Flight"
                          onClick={() => handleChangeFlightClick(v)}
                          style={{
                            backgroundColor: "#ffc107",
                            color: "#fff",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer"
                          }}
                        >
                          <i className="ri-swap-line" />
                        </button>
                      )}

                          <button className="PackageFlight-action-btn edit" onClick={() => showEditDetails(v)}><i className="ri-pencil-fill"/></button>
                          <button className="PackageFlight-action-btn delete" onClick={() => handleOpenDeleteModal(v.packageFlightBookingId)}><i className="ri-delete-bin-fill"/></button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <div className="PackageFlight-empty-state">
                          <i className="ri-plane-line empty-icon"></i>
                          <h5>No Flights Added Yet</h5>
                          <p>Click "Add New Flight" to get started.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
      <ChangeFlightModal 
                show={showChangeFlightModal}
                onHide={() => setShowChangeFlightModal(false)}
                flights={alternativeFlights}
                isLoading={isModalLoading}
                onSelect={handleSelectNewFlight}
                currentlySelectedFlight={currentlySelectedFlightInModal}
            />
    </div>
    
  );
};

export default PackageFlightBooking;